// eslint-disable-next-line @typescript-eslint/no-useless-default-assignment
import {FunctionRating} from 'shared/dtos/function-rating';
import {DataStorageService} from 'shared/services/data-storage.service';

import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-content-component';
import {
  LoehneGesamtesUnternehmen,
  LoehneNachCodierungM1,
  LoehneNachFunktionM1,
  LoehneNachFunktionM2
} from 'shared/dtos/cockpit/funktionenstatistiken';

@Component({
  selector: 'app-chart-dialog-funktionenstatistiken',
  templateUrl: './chart-dialog-funktionenstatistiken-loehne.component.html',
  styleUrls: [
    './chart-dialog-funktionenstatistiken-loehne.component.scss',
    '../cockpit-styles.scss'
  ],
  standalone: false
})
export class ChartDialogFunktionenstatistikenLoehneComponent
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  gesamtesUnternehmen: LoehneGesamtesUnternehmen;
  nachFunktion: LoehneNachFunktionM1[] | LoehneNachFunktionM2[];
  nachCodierung: LoehneNachCodierungM1[];
  funktionen: FunctionRating[];
  isForM2 = false;

  constructor(
    protected readonly translate: TranslateService,
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService
  ) {
    super(translate);
  }

  // eslint-disable-next-line @typescript-eslint/strict-void-return
  async ngOnInit() {
    super.ngOnInit();
    await this.initializeData();
  }

  exportTable1() {
    const cardTitle = this.translate.instant(
      'm1.sprint9.cockpit.card.funktionenstatistiken.lohne.fn.subtitle'
    );
    this.tableExport.exportHtmlTable('funkstat-loehne.fn', cardTitle);
  }

  exportTable2() {
    const cardTitle = this.translate.instant(
      'm1.sprint9.cockpit.card.funktionenstatistiken.bst-anf.subtitle'
    );
    this.tableExport.exportHtmlTable('funkstat-loehne.bst-anf', cardTitle);
  }

  private async initializeData() {
    this.isForM2 = await this.storage.getIsForModule2();
    this.funktionen = await this.storage.getFunktionen();
    const fktStat = (await this.storage.getCockpitData())
      ?.funktionenstatistiken;
    this.nachFunktion = fktStat?.loehne?.nachFunktion;
    this.nachCodierung = fktStat?.loehne?.nachCodierung;
    this.gesamtesUnternehmen = fktStat.loehne.gesamtesUnternehmen;
  }
}
